var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { useState, useEffect } from 'react';
import { Loader } from "../utility";
var Button = function (props) {
    var _a = useState(!!props.loading), loading = _a[0], setLoading = _a[1];
    var _b = useState(), buttonHeight = _b[0], setButtonHeight = _b[1];
    var _c = useState(), buttonWidth = _c[0], setButtonWidth = _c[1];
    var button = React.useRef(null);
    var _d = useState(false), clickedFlag = _d[0], setClickedFlag = _d[1];
    useEffect(function () {
        if (props.loading) {
            setButtonHeight(button.current.clientHeight);
            setButtonWidth(button.current.clientWidth);
        }
        setLoading(!!props.loading);
    }, [props.loading, button.current]);
    return (React.createElement("button", { "aria-label": props.tooltipError, "data-balloon-pos": "up", "data-balloon-visible": !clickedFlag && undefined, ref: button, className: "\n                " + ("BPM-Button " + props.className) + " \n                " + (props.border && 'enable-border') + "  \n                " + (props.selected ? 'selected' : '') + "\n                " + (props.hoverEffect ? 'hoverEnabled' : '') + "\n                " + props.variation + " \n            ", style: __assign(__assign({ background: props.backgroundColor, color: props.textColor }, props.style), { height: loading ? buttonHeight : undefined, width: loading ? buttonWidth : undefined }), type: "button", disabled: props.disabled || props.loading, onClick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            props.onClick && !props.loading && !props.disabled && props.onClick();
        } },
        props.image ? (React.createElement("img", { width: props.imgWidth || 13, src: props.image, alt: "button icon", onClick: function (e) {
                if (props.onImageClick) {
                    e.preventDefault();
                    e.stopPropagation();
                    setClickedFlag(true);
                    props.onImageClick();
                }
            } })) : null,
        React.createElement("span", { className: "btn-text no-select", style: { fontSize: props.fontSize } }, loading ? React.createElement(Loader, { size: "2.8rem", centered: true, white: true, delayDisabled: true }) : props.buttonText),
        props.buttonTextRight !== undefined
            ? React.createElement("span", { className: "right-text", style: { marginLeft: '.4rem', color: props.textColor, fontSize: props.rightTextFontSize || '1.1rem' } }, props.buttonTextRight)
            : null));
};
export default Button;
//# sourceMappingURL=Button.js.map